module.exports = __webpack_public_path__ + "media/images/logo_256-907ac74e.png";